<template>
  <div
    class="collection-grid-header"
    v-if="$mq !== 'mobile' && $mq !== 'tablet'"
  >
    <div class="collection-grid-header__sort-pagination-total-wrapper">
      <collection-total-results></collection-total-results>
      <collection-sorting
        class="sorting"
        :default-sort="defaultSort"
      ></collection-sorting>
    </div>
  </div>
  <div class="collection-grid-header__mobile" v-else>
    <div class="collection-grid-header__mobile-menu">
      <v-button
        secondary
        v-if="!filtersDisabled && filters && filters.length > 0"
        @click="toggleMobileFiltersMenu"
        >Filters</v-button
      >
      <v-button secondary @click="toggleMobileSortingMenu">Sort By</v-button>
    </div>
    <div class="collection-grid-header__mobile-menu-results-wrapper">
      <collection-total-results></collection-total-results>
    </div>
    <collection-mobile-menu-b
      :menu-active="mobileFiltersMenuActive"
      :close-binding="toggleMobileFiltersMenu"
      :enable-apply-button="true"
      :enable-clear-all="true"
      menu-title="Filter"
    >
      <collection-filters-b
        class="collection-grid__filters"
        :tags="tags"
        :filters="filters"
      ></collection-filters-b>
    </collection-mobile-menu-b>
    <collection-mobile-menu-b
      :menu-active="mobileSortingMenuActive"
      :close-binding="toggleMobileSortingMenu"
      menu-title="Sort"
    >
      <collection-sorting
        :default-sort="defaultSort"
        :mobile-click-binding="toggleMobileSortingMenu"
      ></collection-sorting>
    </collection-mobile-menu-b>
  </div>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue'
import Accordion from '../basic/Accordion.vue'
import VLink from '../buttons/VLink.vue'
import VButton from '../buttons/VButton.vue'
import CollectionTotalResults from '@/scripts/components/collection/CollectionTotalResults.vue'
import CollectionPaginationControlsB from '@/scripts/components/collection/CollectionPaginationControlsB.vue'
import CollectionFiltersB from '@/scripts/components/collection/CollectionFiltersB.vue'
import CollectionSorting from '@/scripts/components/collection/CollectionSorting.vue'
import CollectionMobileMenuB from '@/scripts/components/collection/CollectionMobileMenuB.vue'
import { unhandleize } from '../../filters/string.js'

export default {
  name: 'CollectionGridHeaderB',
  components: {
    Icon,
    Accordion,
    VLink,
    VButton,
    CollectionTotalResults,
    CollectionPaginationControlsB,
    CollectionFiltersB,
    CollectionSorting,
    CollectionMobileMenuB
  },
  props: {
    paginationAmount: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    tags: {
      type: Array,
      required: true
    },
    filters: {
      type: Array,
      required: true
    },
    defaultSort: {
      type: String,
      required: true
    },
    filtersDisabled: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      mobileFiltersMenuActive: false,
      mobileSortingMenuActive: false
    }
  },
  methods: {
    toggleMobileFiltersMenu () {
      this.mobileFiltersMenuActive = !this.mobileFiltersMenuActive
    },
    toggleMobileSortingMenu () {
      this.mobileSortingMenuActive = !this.mobileSortingMenuActive
    },
    unhandleizeTitle (handleizedFilter) {
      return unhandleize(handleizedFilter)
    }
  }
}
</script>

<style scoped lang="scss">
.collection-grid-header {
  position: relative;
  padding: 12px 0;

  &__sort-pagination-total-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__pagination-with-total {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;
    .sorting {
      margin-right: 20px;
    }
  }
  &__mobile {
    width: 100%;
    padding-top: 8px;
    &-menu {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      margin: 0 -2px;
      button {
        margin: 8px 2px;
      }
      &-results-wrapper {
        // border-bottom: 1px solid $color-light-grey;
        width: 100%;
        padding: 16px 0;
      }
    }
  }
}
.collection-mobile-accordion {
  min-width: 204px;
  &__global-menu {
    display: flex;
    flex-direction: column;
    padding: 24px 0 16px;
    .top-level {
      border-bottom: 1px solid $color-grey;
      padding: 12px 0 6px;
      font-weight: 600;
      color: $color-black;
    }
    .collection-mobile-accordion__custom-menu-item {
      color: $color-black;
      font-size: 12px;
      font-family: $font-family-primary;
    }

    > a:visited {
      color: $color-black;
    }
  }
}
.remove-bottom-spacing {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}
/deep/ .accordion__menu-title {
  font-family: $font-family-primary;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 20px;
}
</style>
